import React from 'react';
import { Box, Typography, Paper, Grid, Chip, Divider } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import SchoolIcon from '@mui/icons-material/School';
import WorkIcon from '@mui/icons-material/Work';
import CodeIcon from '@mui/icons-material/Code';
import BuildIcon from '@mui/icons-material/Build';

const ContactPage = () => {
  const sectionStyle = { p: 3, mb: 3, borderRadius: '10px', border: '1px solid #e0e0e0' };

  return (
    <Box sx={{ padding: '24px', maxWidth: '1000px', margin: '0 auto' }}>
      
      {/* Header */}
      <Paper sx={{ p: 4, mb: 4, background: 'linear-gradient(135deg, #1a5276, #2c3e50)', borderRadius: '12px', color: 'white' }}>
        <Typography variant="h4" fontWeight={700} gutterBottom>
          👨‍💼 Senior Actuary — Pricing & Reserving
        </Typography>
        <Typography variant="h6" sx={{ opacity: 0.9, fontWeight: 300 }}>
          P&C Insurance • Life & Health • Data Science
        </Typography>
        <Box sx={{ display: 'flex', gap: 2, mt: 2, flexWrap: 'wrap' }}>
          <Chip icon={<LocationOnIcon />} label="Paris, France" sx={{ background: 'rgba(255,255,255,0.15)', color: 'white' }} />
          <Chip icon={<EmailIcon />} label="younes.mouatassim@gmail.com" sx={{ background: 'rgba(255,255,255,0.15)', color: 'white' }} />
          <Chip icon={<PhoneIcon />} label="+33 6 08 50 57 39" sx={{ background: 'rgba(255,255,255,0.15)', color: 'white' }} />
        </Box>
      </Paper>

      {/* Core Competencies */}
      <Typography variant="h5" fontWeight={600} sx={{ mb: 2, color: '#2c3e50' }}>
        🎯 Core Competencies
      </Typography>
      <Grid container spacing={2} sx={{ mb: 4 }}>
        {[
          { title: 'P&C Pricing', desc: 'Frequency-Severity modeling, Pure Premium calculation, GLM (Poisson, Gamma, Tweedie), Exposure curves, Credibility theory, Rate making & tariff optimization.' },
          { title: 'P&C Reserving', desc: 'Chain Ladder, Bornhuetter-Ferguson, Mack method, Bootstrap reserving, IFRS 17 / Solvency II technical provisions, Best Estimate & Risk Margin.' },
          { title: 'Life Insurance', desc: 'Mortality tables construction, Kaplan-Meier, Cox proportional hazards, Multi-state Markov models, ALM, Profit testing, Embedded Value.' },
          { title: 'Health Insurance', desc: 'Claims frequency & severity modeling, IBNR/IBNER reserving, Risk adjustment, Capitation pricing, Medical trend analysis, Long-term care.' },
          { title: 'Dependencies & Copulas', desc: 'Correlation modeling (Pearson, Spearman, Kendall), Gaussian & t-Copulas, Archimedean copulas (Clayton, Gumbel, Frank), Tail dependence, Correlation stress testing.' },
          { title: 'Extreme Value Theory', desc: 'Peaks Over Threshold (POT), Block Maxima (GEV), GPD parameter estimation, VaR / TVaR / Expected Shortfall, Return period analysis.' },
          { title: 'Capital Modelling & Solvency II', desc: 'Standard Formula & Internal Model SCR, Risk aggregation (correlation matrices, copulas), ORSA process, SFCR/RSR reporting, Technical Provisions (Best Estimate + Risk Margin), Monte Carlo simulation.' },
          { title: 'Application Development & AI Agents', desc: 'Build actuarial applications and AI agents using Python (Streamlit, FastAPI, Shiny for Python). LLM-powered agents for automated pricing, reserving, and reporting workflows. Full-stack development (React, Node.js) for insurance platforms.' }
        ].map((item, i) => (
          <Grid item xs={12} md={6} key={i}>
            <Paper sx={{ p: 2.5, borderRadius: '8px', border: '1px solid #e0e0e0', height: '100%', '&:hover': { borderColor: '#1abc9c' } }}>
              <Typography variant="subtitle1" fontWeight={600} sx={{ color: '#1a5276', mb: 1 }}>{item.title}</Typography>
              <Typography variant="body2" sx={{ color: '#555', lineHeight: 1.7 }}>{item.desc}</Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>

      {/* Technical Skills */}
      <Typography variant="h5" fontWeight={600} sx={{ mb: 2, color: '#2c3e50' }}>
        🛠 Technical Skills
      </Typography>
      <Paper sx={{ ...sectionStyle, background: '#f8f9fa' }}>
        <Grid container spacing={2}>
          {[
            { cat: 'Languages', skills: ['R / R Shiny', 'Python (scikit-learn, statsmodels)', 'SAS', 'SQL', 'VBA'] },
            { cat: 'ML & Statistics', skills: ['GLM / GAM', 'Decision Trees (CART)', 'Random Forest', 'GBM / XGBoost', 'Neural Networks', 'Bayesian methods'] },
            { cat: 'Actuarial Tools', skills: ['Prophet', 'AXIS', 'Moses', 'Remetrica', 'Igloo', 'Excel / VBA'] },
            { cat: 'Regulatory', skills: ['Solvency II', 'IFRS 17', 'ORSA', 'SFCR / RSR', 'EIOPA Guidelines', 'PRA requirements'] },
            { cat: 'Visualization', skills: ['Power BI', 'Tableau', 'Plotly', 'ggplot2', 'Excel dashboards'] },
            { cat: 'App Development & AI', skills: ['Python (Streamlit, FastAPI)', 'AI Agents (LangChain, AutoGen)', 'LLM Integration (OpenAI, Claude)', 'Full-Stack (React, Node.js)', 'R Shiny', 'Prompt Engineering'] },
            { cat: 'Cloud & DevOps', skills: ['Git', 'Docker', 'AWS', 'Azure', 'Databricks', 'Linux'] }
          ].map((item, i) => (
            <Grid item xs={12} md={4} key={i}>
              <Typography variant="subtitle2" fontWeight={600} sx={{ color: '#1a5276', mb: 1 }}>{item.cat}</Typography>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                {item.skills.map(s => <Chip key={s} label={s} size="small" variant="outlined" sx={{ fontSize: '11px' }} />)}
              </Box>
            </Grid>
          ))}
        </Grid>
      </Paper>

      

    </Box>
  );
};

export default ContactPage;
